// serviceWorkerRegistration.js

// 🟢 ثبت Service Worker
export function register() {
  if ('serviceWorker' in navigator) {
    const swUrl = '/service-worker.js'; // 👈 مستقیم از روت بگیر، قابل اعتمادتره

    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('✅ Service Worker رجیستر شد.');

          // 🟡 بررسی آپدیت جدید
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // نسخه جدید اومده 👇
                  console.log('🔄 نسخه جدید موجود است؛ ریفرش کنید.');
                  showUpdateToast(); // 🔔 به کاربر اطلاع بده (توابع سفارشی خودت)
                } else {
                  // اولین نصب 👇
                  console.log('📦 محتوا کش شد؛ الان آفلاین هستید.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('❌ خطا در رجیستر SW:', error);
        });
    });
  }
}

// 🛑 پاک کردن Service Worker (برای dev یا دیباگ)
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((reg) => {
          reg.unregister().then(() => {
            console.log('🗑️ Service Worker پاک شد.');
          });
        });
      })
      .catch((error) => console.error('❌ خطا در حذف SW:', error));
  }
}

// 📌 نمونه تابع اطلاع‌رسانی (Toast یا Modal)
// می‌تونی اینو با MUI Snackbar یا SweetAlert2 یا هر UI دیگه جایگزین کنی
function showUpdateToast() {
  const confirmReload = window.confirm('نسخه جدید آماده است. می‌خواهید بروزرسانی کنید؟');
  if (confirmReload) {
    window.location.reload();
  }
}
